import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import ButtonIcon from './ButtonIcon'

// DON NOT REMOVE the comments around 'import style.scss'
// ###STYLE_REPLACEMENT_START###
import './style.scss'
// ###STYLE_REPLACEMENT_END###

const Button = ({
  label,
  url,
  icon,
  iconSize,
  iconPosition,
  iconColor,
  filled,
  inversed,
  kind,
  size,
  expand,
  disabled,
  onClick,
  target,
  extraClasses
}) => {
  const handleClick = (e) => {
    onClick(e)
  }

  const classes = {
    'gdpp-component': true,
    'fil-button': true,
    'fil-button--inversed': inversed,
    [`fil-button--${kind}`]: kind,
    [`fil-button--${size}`]: size,
    'fil-button--expand': expand,
    'fil-button--with-icon': icon,
    [extraClasses]: extraClasses
  }

  return (kind === 'icon' ? '' : url) && !disabled ? (
    <a
      className={classnames(classes)}
      href={url}
      target={target}
      disabled={disabled}
      aria-label={label}
      title={label}
      onClick={handleClick}
    >
      <span className="fil-button--text">
        <ButtonIcon {...{ label, icon, iconSize, iconPosition, filled }} />
      </span>
    </a>
  ) : (
    <button type="button" className={classnames(classes)} disabled={disabled} aria-label={label} title={label} onClick={handleClick}>
      {kind === 'icon' ? (
        <fil-icon {...(filled ? { filled } : {})} color={iconColor} icon={icon} size={iconSize} />
      ) : (
        <span className="fil-button--text">
          <ButtonIcon {...{ label, icon, iconSize, iconPosition, filled }} />
        </span>
      )}
    </button>
  )
}

Button.propTypes = {
  label: PropTypes.string,
  url: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconPosition: PropTypes.oneOf(['left', 'right']),
  iconColor: PropTypes.string,
  filled: PropTypes.bool,
  inversed: PropTypes.bool,
  kind: PropTypes.string,
  size: PropTypes.oneOf(['standard', 'small']),
  expand: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  extraClasses: PropTypes.string,
  target: PropTypes.string
}

Button.defaultProps = {
  label: '',
  url: '',
  icon: '',
  iconSize: 12,
  iconPosition: 'right',
  iconColor: '',
  filled: false,
  inversed: false,
  kind: 'primary',
  size: 'standard',
  expand: false,
  disabled: false,
  onClick: () => {},
  extraClasses: '',
  target: '_blank'
}

export default Button
